'use strict';
var collection = require('../internals/collection');
var collectionStrong = require('../internals/collection-strong');

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.map.constructor.js
// module id = 1323
// module chunks = 0